import React, { useState, useContext, useCallback, useEffect } from 'react';
import { getChatSettings, getChatBots, getUserId, getAgent } from './client';

export const ChatContext = React.createContext();

const defaultChat = {
  show: false,
  mob_no: '',
  can_chat: false,
  user: [],
};

export const ChatProvider = ({ children, chat }) => {
  const [currentChat, setCurrentChat] = useState(chat || defaultChat);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isLoadingEmpty, setLoadingEmpty] = useState(false);
  const [kanban, setKanban] = useState(false);
  const [hasChannel, setHasChannel] = useState(false);
  const [showChannel, setChannelModal] = useState(false);
  const [chatSetting, setChatSetting] = useState(false);
  const [status, setStatus] = useState('bot');
  const [toRemove, setToRemove] = useState();
  const [selectedMobNo, setSelectedMobNo] = useState([]);
  const [checkboxVisibility, setCheckboxVisibility] = useState([]);
  const [selectedSessionId, setSessionId] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [active, setActive] = useState();
  const [canPlayAudio, setCanPlayAudio] = useState(false);
  const [isEnabledSmartRouting, setIsEnabledSmartRouting] = useState(false);
  const [contactInfo, setContactInfo] = useState();
  const [hasYeastarConfig, setHasYeastarConfig] = useState(false);
  const [msgCount, setMsgCount] = useState();
  const [supportEmail, setSupportEmail] = useState();

  const [userInfo, setUserInfo] = useState('');

  const saveChat = (values) => {
    setLoading(true);
    setCurrentChat(values);
    setLoading(false);
  };

  const refresh = useCallback(
    () => setShouldRefresh(!shouldRefresh),
    [shouldRefresh]
  );

  useEffect(() => {
    const handleUserInteraction = () => {
      setCanPlayAudio(true);
      window.removeEventListener('click', handleUserInteraction);
      window.removeEventListener('keydown', handleUserInteraction);
      window.removeEventListener('touchstart', handleUserInteraction);
    };

    window.addEventListener('click', handleUserInteraction);
    window.addEventListener('keydown', handleUserInteraction);
    window.addEventListener('touchstart', handleUserInteraction);

    return () => {
      window.removeEventListener('click', handleUserInteraction);
      window.removeEventListener('keydown', handleUserInteraction);
      window.removeEventListener('touchstart', handleUserInteraction);
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    getChatSettings()
      .then((result) => {
        if (result && result.data) {
          if (result.data[0]?.smart_routing?.enabled) {
            setIsEnabledSmartRouting(result.data[0]?.smart_routing?.enabled);
          }
          setKanban(result.data[0].view_type);
          setChatSetting(result.data[0].user_id);

          setLoading(false);
        }
      })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoadingEmpty(true);
    getChatBots()
      .then((result) => {
        if (result && result.data.length > 0) {
          if (
            result.data.some(
              (bot) =>
                bot.channel === 'voice_call' &&
                bot.connector === 'Yeastar' &&
                bot.active
            )
          ) {
            setHasYeastarConfig(true);
          }
          setSupportEmail(result.data[0].support_email);
          setHasChannel(true);
          setLoadingEmpty(false);
        }
        setLoadingEmpty(false);
      })
      .catch(() => {
        setLoadingEmpty(false);
      });
  }, []);

  useEffect(() => {
    getAgent({ id: getUserId() }).then((res) => {
      setUserInfo(res.data);
    });
  }, []);

  return (
    <ChatContext.Provider
      value={{
        chat: currentChat,
        saveChat,
        refresh,
        isLoading,
        setLoading,
        setKanban,
        kanban,
        hasChannel,
        setChannelModal,
        showChannel,
        setLoadingEmpty,
        isLoadingEmpty,
        setChatSetting,
        chatSetting,
        status,
        setSelectedMobNo,
        selectedMobNo,
        setStatus,
        setToRemove,
        toRemove,
        setSessionId,
        selectedSessionId,
        setSelectAll,
        selectAll,
        setCheckboxVisibility,
        checkboxVisibility,
        setActive,
        active,
        canPlayAudio,
        setContactInfo,
        contactInfo,
        isEnabledSmartRouting,
        setIsEnabledSmartRouting,
        setHasYeastarConfig,
        hasYeastarConfig,
        userInfo,
        setUserInfo,
        setMsgCount,
        msgCount,
        supportEmail,
        defaultChat,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const chatContext = () => useContext(ChatContext);
